// RoomSelectField — brief 84 band B, candidate B39.
// The meeting-room select the agenda modal and the meeting dialog rendered
// identically — one rename family (form/setForm vs mtgDlg/setMtgDlg, p vs d)
// carried by the props, named after the donor's free identifiers. The
// candidate's other two blocks (the priority select pair) use a different
// update mechanism (a setForm closure vs updateField) — a structural hunk,
// so they stay in src/App.tsx as declared survivors.

import FieldSelect from "./FieldSelect";

// 154B §2 — the field row IS FieldSelect's shape (.field + <label> +
// select.field-input), so the conversion is the primitive itself and not a
// MenuSelect mount. The id is carried as a string because that is what an
// <option value> was: the number round-trips through `Number(v)` exactly as it
// round-tripped through `Number(e.target.value)`.
export function RoomSelectField({ form, setForm, t, mtgRooms }: any) {
  return (
                    <FieldSelect
                      label={t("modal.meeting.room", { fallback: "Meeting room" })}
                      value={form.roomPlaceId != null ? String(form.roomPlaceId) : ""}
                      onChange={(v) =>
                        setForm((p: any) => ({
                          ...p,
                          roomPlaceId: v ? Number(v) : null,
                          roomOverride: false,
                        }))
                      }
                      options={[
                        [
                          "",
                          t("modal.meeting.no_room", {
                            fallback: "— No room reservation —",
                          }),
                        ] as const,
                        ...(mtgRooms || []).map(
                          (p: any) => [String(p.id), String(p.name)] as const,
                        ),
                      ]}
                    />
  );
}
